export default {"src":"/_next/static/media/sn.c81eda62.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};